import type { FilterConditionDto } from './condition';
import { BdCondition } from './condition';

export abstract class BdEqualsCondition<T> extends BdCondition {
  protected constructor(
    id: string,
    public equals: T | null = null,
  ) {
    super(id);
  }

  toJSON(): FilterConditionDto {
    return {
      [this.id]: {
        equals: this.equals,
      },
    };
  }
}
